import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { ConsultaFuenteI } from 'src/app/modelos/ConsultaFuente';
import { EstadoInfoChvI } from 'src/app/modelos/EstadoInformacionChv';
import { fuenteI } from 'src/app/modelos/fuentes.interface';
import { HistEstaInfoI } from 'src/app/modelos/HistorialEstadoInfo';
import { PeriodoReporteI } from 'src/app/modelos/PeriodoReporte';
import { ResCargueExcel } from 'src/app/modelos/ResCargueExcel';
import { ResConsultaExcel } from 'src/app/modelos/ResConsulta';
import { VistaAdminInfoI } from 'src/app/modelos/VistaAdminInfo';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AdmininformacionService } from 'src/app/servicios/admininfo/admininformacion.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import { AnalisisService } from 'src/app/servicios/analisis/analisis.service';
import { DataTableDirective } from 'angular-datatables';
import { UsuarioI } from 'src/app/modelos/usuario.interface';


@Component({
  selector: 'app-consultarinforchv',
  templateUrl: './consultarinforchv.component.html',
  styleUrls: ['./consultarinforchv.component.css']
})
export class ConsultarinforchvComponent implements OnDestroy,OnInit {

  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject<any>();
  aniosVigen: Number[];
  PeriodoSeleccionado : PeriodoReporteI = new PeriodoReporteI;
  anioConsulta : Number = 0;
  consucutivoConsulta : Number = 0;

  PeriodosConsultar : PeriodoReporteI[];
  IdPeriodoConsulta : BigInteger;
  ListaEstadosFuentes : VistaAdminInfoI[];
  EstadoVerObservaciones : EstadoInfoChvI = new EstadoInfoChvI;
  FuenteVerObservaciones : fuenteI = new fuenteI;
  HistorialVerObservaciones : HistEstaInfoI = new HistEstaInfoI;
  usuarioAprobo : UsuarioI = new UsuarioI;
  rolUsuAprobo : String = "";
  PeriodoModalVerOnservacion : String;
  CargueMasivo : ConsultaFuenteI = new ConsultaFuenteI;
  ResultadoConsulta : ResCargueExcel[];
  ResultadoConsultaBase : ResCargueExcel[];
  isButtonBaseHistoricaDisabled: Boolean = false;

  @ViewChild('OpenModalObservacionesCargue') OpenModalObservacionesCargue: ElementRef;
  @ViewChild('CloseModalObservacionesCargue') CloseModalObservacionesCargue: ElementRef;

  constructor(
    private api:ApiService,
    private router:Router,
    private toastr: ToastrService,
    private appService:AppServiceService,
    private analisisService:AnalisisService,
    private admininfo:AdmininformacionService
  ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      responsive: true,
      language:
        {
          "processing": "Procesando...",
          "lengthMenu": "Mostrar _MENU_ registros",
          "zeroRecords": "No se encontraron resultados",
          "emptyTable": "Ningún dato disponible en esta tabla",
          "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "infoFiltered": "(filtrado de un total de _MAX_ registros)",
          "search": "Buscar:",
          "loadingRecords": "Cargando...",
          "paginate": {
              "first": "Primero",
              "last": "Último",
              "next": "Siguiente",
              "previous": "Anterior"
          },
          "aria": {
              "sortAscending": ": Activar para ordenar la columna de manera ascendente",
              "sortDescending": ": Activar para ordenar la columna de manera descendente"
          },
          "info": "Mostrando de _START_ a _END_ de _TOTAL_ estados"
        }
    };
    this.analisisService.consultarPeriodoActivoCHV().subscribe(PActivo=>{
      this.anioConsulta = Number(PActivo.anio);
      this.consucutivoConsulta = Number(PActivo.consecutivoPeriodo);
    });
    this.admininfo.TodosEstadosPeriodoActivoAdminInfoChv().subscribe(result1=>{
      this.ListaEstadosFuentes = result1;
      this.dtTrigger.next();
    });
    this.analisisService.getListaAniosVigenciaChv().subscribe(respuesta0=>{
      this.aniosVigen = respuesta0;
    });
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  RegresarAdminChv(){
    this.router.navigate(['admininfochv']);
  }

  CosultarListaEstados(){
    if(this.consucutivoConsulta==0 || this.anioConsulta == 0){
      console.log("Seleccione periodo completo");
    } else {
      this.api.PeriodoPorConsecutivoAnio(this.consucutivoConsulta, this.anioConsulta).subscribe(resultado1=>{
        this.PeriodoSeleccionado = resultado1;
        this.api.EstadosInfoParaPeriodoChv(resultado1.id).subscribe(Lista2=>{
          this.ListaEstadosFuentes = Lista2;
          this.reinicializarDataTable();
        });
      });
    }
  }

  reinicializarDataTable(): void {
    this.dtElement.dtInstance.then((dtInstance: any) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  VerObservaciones(idEstadoInf){
    this.rolUsuAprobo = "";
    this.OpenModalObservacionesCargue.nativeElement.click();
    this.api.ConsultarEstadoInfoPorId(idEstadoInf).subscribe(result3=>{
      this.EstadoVerObservaciones = result3;
      this.PeriodoModalVerOnservacion = result3.anio + " - " + result3.periodo;
      this.api.getFuenteById(result3.fuente.id).subscribe(result4=>{
        this.FuenteVerObservaciones = result4;
        this.api.HistEstadoInfAprobada(this.EstadoVerObservaciones.id,result4.id).subscribe(result5=>{
          this.HistorialVerObservaciones = result5;
          /*this.api.getUsuarioByUsername(result5.usuario).subscribe(result=>{
            this.usuarioAprobo = result;
          });*/
          this.rolUsuAprobo = this.verificarPrimerosCaracteres(result5.usuario);
        });
      });
    });
  }

  verificarPrimerosCaracteres(cadena) {
    const primerosDos = cadena.substring(0, 2);

    if (primerosDos === 'ad' || primerosDos === 'AD') {
      return "Administrador";
    }else if (primerosDos === 'te' || primerosDos === 'TE') {
      return "Temático";
    }else if (primerosDos === 'co' || primerosDos === 'CO') {
      return "Coordinador";
    }else{
      return "Migración";
    }

  }

  ConsultarHistorico(idEstadoInf){
    this.api.ConsultarEstadoInfoPorId(idEstadoInf).subscribe(result6=>{
      this.CargueMasivo.anio = result6.anio.toString();
      this.CargueMasivo.trimestre = result6.periodo;
      this.api.getFuenteById(result6.fuente.id).subscribe(result7=>{
        this.CargueMasivo.cod_entidad = result7.codEnti;
        this.CargueMasivo.idFuente = result7.id;
        this.api.consultarHistoricoCHV(this.CargueMasivo).subscribe(Result23 =>{
          this.ResultadoConsulta = Result23;

          let titulosColumas = ["Consecutivo", "Año", "Trimestre", "Código superintendencia", "Código tipo entidad", "Código entidad", "Tipo crédito", "Departamento", "Municipio", "Solución vivienda", "Tenedor", "Moneda", "Rango vivienda", "Mora", "Número créditos", "Saldo capital total", "Capital una o mas cuotas vencidas", "Tasa"];
          let base64 = this.appService.generateExcelBase64AdminInfoConsultarInfoHistorico(titulosColumas, Result23);

          this.descargarArchivo(base64, "Consulta "+this.CargueMasivo.anio+" - "+this.CargueMasivo.trimestre+" "+result7.codEnti+".xlsx");
        });
      });
    });

  }

  generarExcelInformacionConsultarInfo(){
    let titulosColumas = ["Periodo", "NIT", "Razón social", "Departamento", "Municipio", "Estado cargue", "Estado fuente", "Novedad"];
    let base64 = this.appService.generateExcelBase64AdminInfoConsultarInformacion(titulosColumas, this.ListaEstadosFuentes);
    let nombreArch = "Estado informacion "+this.anioConsulta+" - "+this.consucutivoConsulta+".xlsx";

    this.descargarArchivo(base64, nombreArch);
  }

  descargarArchivo(stringBase64, nombreArchivo) {
    if (stringBase64) {
      const blob = this.base64toBlob(stringBase64);
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = nombreArchivo;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } else {
      console.error('No hay datos para descargar');
    }
  }

  base64toBlob(base64Data: string): Blob {
    const sliceSize = 512;
    const byteCharacters = atob(base64Data);
    const byteArrays: Uint8Array[] = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  }

  generarExcelBaseHistorica(){
    this.isButtonBaseHistoricaDisabled = true;

    this.CargueMasivo.anio = this.anioConsulta;
    this.CargueMasivo.trimestre = this.consucutivoConsulta;

    this.admininfo.consultarBaseHistoricaCHV(this.CargueMasivo).subscribe(Result =>{
      this.ResultadoConsultaBase = Result;

      let titulosColumas = ["Año", "Trimestre", "Código superintendencia", "Código tipo entidad", "Código entidad", "Tipo crédito", "Departamento", "Municipio", "Solución vivienda", "Tenedor", "Moneda", "Rango vivienda", "Mora", "Número créditos", "Saldo capital total", "Capital una o mas cuotas vencidas", "Tasa"];
      let base64 = this.appService.generateCSVBase64AdminInfoConsultarBaseHistoricaCHV(titulosColumas, Result);

      this.descargarArchivo(base64, "Base Historica "+this.anioConsulta+" - "+this.consucutivoConsulta+".csv");

      this.isButtonBaseHistoricaDisabled = false;
    });
  }





}

